// Sovelluksen versionumero yhdessä paikassa.
//
// Aiemmin tämä oli kovakoodattuna erikseen PlayerView'ssä ja
// AdminView'ssä, ja molemmat jäivät 4.0.0:aan kun muu repo siirtyi
// 4.0.1:een. Näytöllä näkyvä versio ei siis kertonut mitä koodia
// selain ajoi — mikä on juuri se asia, jota sillä yritetään todeta.
//
// Pidetään synkassa: package.json, public/version.json ja Androidin
// versionName.
//
// public/version.json ei ole enää pelkkä kirjanpitoa varten: src/useAppUpdate.ts
// vertaa sitä tähän vakioon ja tarjoaa päivitystä kun ne eroavat. Jos tämä
// jää nostamatta deployn yhteydessä, kehotusta ei tule ja PWA-käyttäjä jää
// vanhaan bundleen — juuri se vika jonka takia tarkistus tehtiin.
export const APP_VERSION = "4.7.4";
